module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/68/assets/images/3b92f8609d0397747b90f953900b35db.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_rocket.svg
// module id = qfDu
// module chunks = 0